import { useEffect, useMemo } from 'react';
import { getGeneralSettings, selectGeneralSettings, selectSettingsIsLoading } from '../feature';
import { useAppDispatch, useAppState } from '@/store';

export const useGetGeneralSettings = () => {
  const dispatch = useAppDispatch();
  const generalSettings = useAppState(selectGeneralSettings);
  const isLoading = useAppState(selectSettingsIsLoading);

  useEffect(() => {
    dispatch(getGeneralSettings());
  }, []);

  return useMemo(() => ({ generalSettings, isLoading }), [generalSettings, isLoading]);
};
